import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { pageImages } from '../../data/siteData';
import PagePhotoViewer from '../../elements/PagePhotoViewer';

const page = {
  "slug": "warehouses",
  "title": "Warehouses",
  "summary": "Compact baling systems and material handling for lower to medium volume packaging waste.",
  "image": "equipment/vertical-balers/vertical-3.jpg",
  "highlights": [
    "Material-specific recommendations",
    "Baler loading and discharge planning",
    "Serviceable equipment design"
  ],
  "section": "Industries"
};

const navItems = [
  {
    "slug": "paper-mills",
    "title": "Paper Mills"
  },
  {
    "slug": "corrugated-container-manufacturers",
    "title": "Corrugated Container Manufacturers"
  },
  {
    "slug": "nonwoven-mills",
    "title": "Nonwoven Mills"
  },
  {
    "slug": "textile-mills-cotton-gins",
    "title": "Textile Mills & Cotton Gins"
  },
  {
    "slug": "distribution-centers",
    "title": "Distribution Centers"
  },
  {
    "slug": "manufacturers-industrial-plants",
    "title": "Manufacturers & Industrial Plants"
  },
  {
    "slug": "warehouses",
    "title": "Warehouses"
  },
  {
    "slug": "recycling-centers",
    "title": "Recycling Centers"
  }
];

const images = pageImages['warehouses'];


function Warehouses() {
  return (
    <main className="detail-main">
      <section className="detail-layout">
        <aside>
          <span className="eyebrow">In This Section</span>
          {navItems.map((item) => (
            <Link key={item.slug} className={item.slug === page.slug ? 'active' : ''} to={`/${item.slug}`}>{item.title}</Link>
          ))}
        </aside>
        <article className="article">
          <span className="eyebrow">{page.section}</span>
          <h2>{page.title}</h2>
          <div className="body-copy page-summary-copy">{page.summary}</div>
          {page.highlights?.length ? (
            <div className="page-summary-notes">
              {page.highlights.map((item) => <span key={item}>{item}</span>)}
            </div>
          ) : null}
          <PagePhotoViewer title={page.title} images={images} leadText={"Warehouses often need practical equipment for lower to medium volume cardboard, paper, and packaging streams without overcomplicating the workflow."} eyebrow="Application Photos" />
          <div className="content-stack">
            <section className="content-block">
              <h3>Warehouse Baling Needs</h3>
              <div className="body-copy">Warehouses often need practical equipment for lower to medium volume cardboard, paper, and packaging streams without overcomplicating the workflow.</div>
              <div className="body-copy">Depending on volume, C+M can point customers toward <strong>vertical down-stroke balers</strong>, <strong>closed-end manual tie</strong> balers, cart handling, or compactors.</div>
              <div className="detail-points">
                <div className="detail-point">Lower and medium volume packaging waste</div>
                <div className="detail-point">Vertical or horizontal baler selection</div>
                <div className="detail-point">Simple serviceable equipment layouts</div>
              </div>
            </section>
          </div>
          <Link className="button" to="/contact/request-quote">Request a Quote <ArrowRight size={16} /></Link>
        </article>
      </section>
    </main>
  );
}

export default Warehouses;
